import * as React from "react";
import type { SVGProps } from "react";

interface GoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Goal = ({ cancelled = false, ...props }: GoalProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1.75 2.35)">
        <ellipse
          cx={10.278}
          cy={9.75}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.913}
          rx={9.749}
          ry={9.699}
        />
        <ellipse
          cx={10.278}
          cy={9.75}
          stroke="#000"
          strokeWidth={1.3}
          rx={9.443}
          ry={9.393}
        />
      </g>
      <path
        fill="#000"
        d="m9.755 9.935 4.013-.558 1.904 3.619-2.928 2.831-3.72-1.87zM4.097 7.526q.723-1.41 1.271-1.946.55-.537 1.982-1.234l1.817.824L7.99 8.294 4.822 9.377zM21.53 11.854q-.09 1.417-.203 2.173-.114.757-.835 2.131l-2.263.182-.516-2.928 1.614-3.376zM15.97 20.623q-1.5.674-2.268.734t-2.437 0l-1.412-1.903 3.473-1.551 2.853.503zM4.59 18.03q-1.03-1.065-1.223-1.806a14 14 0 0 1-.318-1.69l1.278-2.608 2.281 2.708.289 3.595zM14.092 3.41q1.219.138 1.925.443.705.305 1.854 1.353l.17 1.81-3.566-.154-2.702-2.307z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Goal;
